<template>
  <div>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">
      <!--类型-->
      <el-form-item label="类型" prop="type" :label-width="formLabelWidth">
        <el-select v-model="formData.type" @change="typeChange">
          <el-option label="顶级" :value="0"></el-option>
          <el-option :label="item.name" :value="item.key_name" :key="item.key_name" v-for="item in typeData"></el-option>
        </el-select>
      </el-form-item>

      <!--所属分类-->
      <el-form-item label="所属分类" prop="parent_id" :label-width="formLabelWidth">
        <el-cascader size="small" v-model="parentsVal" :options="cateList" :props="propsParam" @change="handleChange"></el-cascader>
      </el-form-item>

      <!--分类名称-->
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="formData.name" autocomplete="off" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="分类标签" prop="label_id" :label-width="formLabelWidth" v-if="formData.level == 1">
        <el-select v-model="formData.label_id" @change="typeChange">
          <el-option label="顶级" :value="0"></el-option>
          <el-option :label="v.title" :value="v.id" :key="v.id" v-for="v in labelData"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="说明" prop="intro" :label-width="formLabelWidth" v-if="formData.type == 20 || (formData.type == 71 && formData.level == 2)">
        <el-input type="textarea" v-model="formData.intro" :rows="5" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="图片" :label-width="formLabelWidth" v-if="formData.type == 20 || formData.type == 83">
        <div class="img-item">
          <div class="addimg-select" @click="openUpload('image')" v-if="!formData.image"><i class="el-icon-plus"></i></div>
          <el-image class="imgw100" v-else :src="formData.image" fit="cover" alt="" :preview-src-list="[formData.image]" />
          <a v-if="formData.image" href="javascript:void(0);" class="delete-btn" @click.stop="delImg"><i class="el-icon-close"></i></a>
        </div>
        <p class="gray9">建议尺寸200x200px</p>
      </el-form-item>

      <el-form-item label="必看标题" prop="explain_title" :label-width="formLabelWidth" v-if="(formData.type == 60 && formData.level == 2) || ((formData.type == 70 ||formData.type == 71) && formData.level == 1)">
        <el-input v-model="formData.explain_title" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="练习必看内容" prop="explain_content" :label-width="formLabelWidth" v-if="(formData.type == 60 && formData.level == 2) || ((formData.type == 70 ||formData.type == 71) && formData.level == 1)">
        <el-input type="textarea" v-model="formData.explain_content" :rows="5" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="激活码提醒文字" prop="code_tips" :label-width="formLabelWidth" v-if="(formData.type == 60 && formData.level == 2) || ((formData.type == 70 ||formData.type == 71) && formData.level == 1)">
        <el-input type="textarea" v-model="formData.code_tips" :rows="3" placeholder="请输入"></el-input>
      </el-form-item>

      <el-form-item label="激活码提醒图片" prop="code_tips_image_id" :label-width="formLabelWidth">
        <SingleImg :config="{name:'codetipsimage'}" :image="formData.codetipsimage" :styles="{width:'100px', height:'100px'}" fit="contain" @return="returnImgFunc"></SingleImg>
        <span class="gray9">尺寸：500x500px</span>
      </el-form-item>

      <template v-if="formData.type == 60 && formData.level == 2">
        <el-form-item label="发布时间" prop="release_time" :label-width="formLabelWidth">
          <el-date-picker v-model="formData.release_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="满分（分）" prop="full_score" :label-width="formLabelWidth">
          <el-input v-model="formData.full_score" autocomplete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="及格（分）" prop="pass_score" :label-width="formLabelWidth">
          <el-input v-model="formData.pass_score" autocomplete="off" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="时限（分钟）" prop="valid_minute" :label-width="formLabelWidth">
          <el-input v-model="formData.valid_minute" autocomplete="off" placeholder="请输入"></el-input>
        </el-form-item>
      </template>

      <!--是否需要激活-->
      <el-form-item label="是否收费" prop="is_lock" :label-width="formLabelWidth" v-if="formData.type != 83">
        <el-radio-group v-model="formData.is_lock">
          <el-radio :label="1">收费</el-radio>
          <el-radio :label="0">免费</el-radio>
        </el-radio-group>
        <p class="gray9">需要激活码激活</p>
      </el-form-item>

      <!--精品课程-->
      <!-- <template v-if="formData.type == 83 && formData.level == 2">
      <el-form-item label="视频地址：" prop="video_url" :label-width="formLabelWidth">
        <el-input v-model="formData.video_url" class="max-w460">
          <el-button slot="append" icon="el-icon-upload" @click="openUpload('video')">选择视频</el-button>
        </el-input>
      </el-form-item>
      
      <el-form-item label="虚拟阅读量" prop="virtual_views" :label-width="formLabelWidth">
        <el-input type="number" v-model="formData.virtual_views" placeholder="请输入数字" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="内容" prop="content" :label-width="formLabelWidth">
        <div class="edit_container">
          <Uediter v-model="formData.content" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      </template> -->

      <!--是否显示-->
      <el-form-item label="是否显示" prop="status" :label-width="formLabelWidth">
        <el-radio-group v-model="formData.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <!--排序-->
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth"><el-input v-model="formData.sort" placeholder="请输入排序" type="number"></el-input></el-form-item>
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="onSubmit()" :disabled="loading">确 定</el-button>
    </div>
  </el-dialog>
  <!--图片组件-->
  <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import CategoryApi from '@/api/study/category.js';
import { deepClone } from '@/utils/base.js';
import Upload from '@/components/file/Upload';
import Uediter from '@/components/UE.vue';
import SingleImg from '@/components/image/Single';
export default {
  components: {
    Upload,
    Uediter,
    SingleImg
  },
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {
        type: '',
        /*分类名称*/
        name: '',
        intro: '',
        image: '',
        images_id: 0,
        /*是否显示*/
        is_show: 0,
        /*排序*/
        sort: 100,
        /*父集ID*/
        parent_id: 0,
        /*状态*/
        status: 1,
        is_lock: 0,
        full_score: 100,
        pass_score: 60,
        valid_minute: 120,
        content: '',
        release_time: '',
        code_tips_image_id: 0,
        codetipsimage: {
          file_id: 0,
          file_path: ''
        },
      },
      /*验证规则*/
      formRules: {
        type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        full_score: [{ required: true, message: '请输入满分', trigger: 'blur' }],
        pass_score: [{ required: true, message: '请输入及格', trigger: 'blur' }],
        valid_minute: [{ required: true, message: '请输入时限', trigger: 'blur' }],
      },
      /*当前父集ID*/
      parentsVal: [],
      /*分类列表*/
      cateList: [],
      /*排序*/
      srot: '1',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      /*展示数据*/
      propsParam: {
        label: 'name',
        value: 'category_id',
        checkStrictly: true
      },
      isupload: false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
    };
  },
  props: {
    open_edit:Boolean,
    add_type:String,
    rawData:Array,
    typeData:Object,
    labelData:Array,
    selectModel:Object
  },
  created() {
    this.dialogVisible = this.open_edit;
    this.cateList = deepClone(this.rawData);
    this.cateList.unshift({name:'顶级',category_id:0})
    this.formData=deepClone(this.selectModel);
    this.ueditor.text = this.formData.content;
    this.formData.image = this.formData.image ? this.formData.image.file_path : '';
    // this.formData.release_time = this.formData.release_time ? this.formData.release_time : new Date();
    this.findParentsID(this.cateList);
  },
  methods: {
    /*选择分类*/
    handleChange(e) {
      this.formData.level = e.length+1;
    },

    /*选择类型*/
    typeChange(){
      CategoryApi.getList({type:this.formData.type}, true)
        .then(res => {
          if (res.code == 1) {
            this.cateList = res.data.list
          }
        });
    },

    /*查找父集id*/
    findParentsID(list){
      let flag=false;
      for(let i=0;i<list.length;i++){
        let item=list[i];
        if(item.category_id==this.formData.parent_id){
          this.parentsVal.unshift(item.category_id);
          flag=true;
          break;
        }else{
          let children=item.children;
          if(typeof children!='undefined'&&children.length>0){
              if(this.findParentsID(children)){
                this.parentsVal.unshift(item.category_id);
                flag=true;
                break;
              }
          }
        }
      }
      return flag;
    },

    /*修改分类*/
    onSubmit() {
      let self = this;
      let params = self.formData;
      console.log(self.formData);
      if(self.parentsVal.length>0){
        params.parent_id=self.parentsVal[self.parentsVal.length-1];
      }
      params.children = [];
      // 图片处理
      if (params.codetipsimage&&params.codetipsimage.file_id){
        params.code_tips_image_id = params.codetipsimage.file_id;
      }
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CategoryApi.edit(params, true)
            .then(res => {
              if (res.code == 1) {
                self.$message({
                  message: res.msg,
                  type: 'success',
                });
                self.$emit('closeDialog', {
                  type: 'success',
                  openDialog: false,
                  data:params
                });
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      this.$emit('closeDialog', {
        type: 'error',
        openDialog: false
      });
    },

    /*上传*/
    openUpload(e) {
        this.isupload = true;
    },
    delImg(){
      this.formData.image_id='';
      this.formData.image='';
    },
    /*获取图片*/
    returnImgsFunc(e) {
        if (e != null) {
            this.formData.image = e[0].file_path;
            this.formData.image_id = e[0].file_id;
        }
        this.isupload = false;
    },
    returnImgFunc(name, e){
      if (e != null) {
        this.formData.codetipsimage = e;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/category/part/Edit.vue